export default __webpack_public_path__ + "static/otterscan-b8db2505da8d6b7f1df002795deb738e.jpg";